import React from "react";
import { InlineMath } from "react-katex";

import PolylineGraphInput from "../../../../components/GraphPlotter/tasks/PolylineGraphInput";

const X_RANGE = [-8, 8];
const Y_RANGE = [-8, 8];
const EDGE_MARGIN = 1;

const baseShapes = [
  [
    { x: -4, y: -1, closed: true },
    { x: -2, y: 1, closed: true },
    { x: 0, y: 0, closed: true },
    { x: 3, y: 2, closed: false },
  ],
  [
    { x: -4, y: 2, closed: false },
    { x: -1, y: -1, closed: true },
    { x: 2, y: -1, closed: true },
    { x: 4, y: 1, closed: true },
  ],
  [
    { x: -3, y: -2, closed: true },
    { x: -1, y: 1, closed: true },
    { x: 1, y: 1, closed: true },
    { x: 3, y: -1, closed: false },
  ],
  [
    { x: -2, y: 2, closed: true },
    { x: 0, y: -1, closed: true },
    { x: 2, y: 1, closed: true },
    { x: 4, y: 1, closed: false },
  ],
  [
    { x: -2, y: -1, closed: true },
    { x: -1, y: 2, closed: true },
    { x: 1, y: 0, closed: true },
    { x: 2, y: -2, closed: false },
  ],
  [
    { x: -4, y: -2, closed: false },
    { x: -2, y: 2, closed: true },
    { x: 0, y: 0, closed: true },
    { x: 2, y: -2, closed: true },
  ],
  [
    { x: -4, y: 0, closed: true },
    { x: -2, y: 2, closed: true },
    { x: 0, y: -2, closed: true },
    { x: 4, y: 0, closed: false },
  ],
  [
    { x: -4, y: -2, closed: true },
    { x: -2, y: 0, closed: true },
    { x: 0, y: 2, closed: true },
    { x: 2, y: 2, closed: true },
    { x: 4, y: -2, closed: false },
  ],
  [
    { x: -4, y: 0, closed: false },
    { x: -2, y: -2, closed: true },
    { x: 0, y: -2, closed: true },
    { x: 2, y: 2, closed: true },
    { x: 4, y: 0, closed: true },
  ],
  [
    { x: -2, y: -2, closed: true },
    { x: -1, y: 0, closed: true },
    { x: 0, y: 2, closed: true },
    { x: 1, y: -2, closed: true },
    { x: 2, y: 0, closed: false },
  ],
  [
    { x: -2, y: 2, closed: false },
    { x: -1, y: -2, closed: true },
    { x: 0, y: 0, closed: true },
    { x: 1, y: 2, closed: true },
    { x: 2, y: -2, closed: true },
  ],
  [
    { x: -4, y: 2, closed: true },
    { x: -2, y: 2, closed: true },
    { x: 0, y: -2, closed: true },
    { x: 2, y: 0, closed: true },
    { x: 4, y: -2, closed: false },
  ],
  [
    { x: -6, y: -2, closed: true },
    { x: -3, y: 1, closed: true },
    { x: 0, y: -1, closed: true },
    { x: 3, y: 2, closed: true },
    { x: 6, y: 0, closed: false },
  ],
  [
    { x: -6, y: 1, closed: false },
    { x: -3, y: -2, closed: true },
    { x: 0, y: 2, closed: true },
    { x: 3, y: 0, closed: true },
    { x: 6, y: -1, closed: true },
  ],
  [
    { x: -2, y: -1, closed: true },
    { x: -1, y: 2, closed: true },
    { x: 0, y: 0, closed: true },
    { x: 1, y: -2, closed: true },
    { x: 2, y: 1, closed: false },
  ],
  [
    { x: -2, y: 2, closed: false },
    { x: -1, y: -1, closed: true },
    { x: 0, y: 1, closed: true },
    { x: 1, y: -2, closed: true },
    { x: 2, y: 0, closed: true },
  ],
  [
    { x: -5, y: -3, closed: true },
    { x: -2, y: 0, closed: true },
    { x: 1, y: 3, closed: true },
    { x: 4, y: 0, closed: false },
  ],
  [
    { x: -5, y: 3, closed: false },
    { x: -2, y: 0, closed: true },
    { x: 1, y: -3, closed: true },
    { x: 4, y: 3, closed: true },
  ],
  [
    { x: -5, y: 3, closed: true },
    { x: -2, y: -3, closed: true },
    { x: 1, y: 0, closed: true },
    { x: 4, y: 6, closed: false },
  ],
  [
    { x: -6, y: -6, closed: true },
    { x: -3, y: 3, closed: true },
    { x: 0, y: -3, closed: true },
    { x: 3, y: 6, closed: true },
    { x: 6, y: 0, closed: false },
  ],
  [
    { x: -6, y: 3, closed: false },
    { x: -3, y: -6, closed: true },
    { x: 0, y: 0, closed: true },
    { x: 3, y: 6, closed: true },
    { x: 6, y: -3, closed: true },
  ],
  [
    { x: -5, y: -3, closed: true },
    { x: -2, y: 6, closed: true },
    { x: 1, y: 0, closed: true },
    { x: 4, y: -6, closed: true },
    { x: 6, y: 3, closed: false },
  ],
  [
    { x: -7, y: 6, closed: false },
    { x: -4, y: 0, closed: true },
    { x: -1, y: -6, closed: true },
    { x: 2, y: 3, closed: true },
    { x: 5, y: -3, closed: true },
  ],
  [
    { x: -6, y: 2, closed: true },
    { x: -3, y: -1, closed: true },
    { x: 0, y: 3, closed: true },
    { x: 3, y: -2, closed: true },
    { x: 6, y: 1, closed: false },
  ],
  [
    { x: -6, y: -1, closed: false },
    { x: -3, y: 2, closed: true },
    { x: 0, y: -2, closed: true },
    { x: 3, y: 1, closed: true },
    { x: 6, y: -3, closed: true },
  ],
  [
    { x: -6, y: 0, closed: true },
    { x: -3, y: 3, closed: true },
    { x: 0, y: -2, closed: true },
    { x: 3, y: 2, closed: true },
    { x: 6, y: -1, closed: false },
  ],
  [
    { x: -2, y: -3, closed: true },
    { x: -1, y: 6, closed: true },
    { x: 0, y: -6, closed: true },
    { x: 1, y: 3, closed: true },
    { x: 2, y: 0, closed: false },
  ],
  [
    { x: -2, y: 6, closed: false },
    { x: -1, y: -3, closed: true },
    { x: 0, y: 3, closed: true },
    { x: 1, y: -6, closed: true },
    { x: 2, y: 0, closed: true },
  ],
];

const factorFamilies = {
  verticalPositive: { kind: "vertical", factors: [2, 3, 0.5, 1 / 3] },
  verticalNegative: { kind: "vertical", factors: [-2, -3, -0.5, -1 / 3] },
  horizontalPositive: { kind: "horizontal", factors: [2, 3, 0.5, 1 / 3] },
  horizontalNegative: { kind: "horizontal", factors: [-2, -3, -0.5, -1 / 3] },
};

const legacyFamilyAliases = {
  vertical: "verticalPositive",
  horizontal: "horizontalPositive",
  verticalPositiveInteger: "verticalPositive",
  verticalPositiveFraction: "verticalPositive",
  horizontalInteger: "horizontalPositive",
  horizontalFraction: "horizontalPositive",
};

function pick(array) {
  return array[Math.floor(Math.random() * array.length)];
}

function normalizePoint(point, index, length) {
  return {
    x: Number(point.x),
    y: Number(point.y),
    closed: index === 0 || index === length - 1 ? point.closed !== false : true,
  };
}

function samePoints(userPoints = [], expectedPoints = []) {
  if (!Array.isArray(userPoints) || userPoints.length !== expectedPoints.length) return false;

  return expectedPoints.every((expected, index) => {
    const got = normalizePoint(userPoints[index], index, userPoints.length);
    const want = normalizePoint(expected, index, expectedPoints.length);
    return got.x === want.x && got.y === want.y && got.closed === want.closed;
  });
}

function inRange(points, xRange = X_RANGE, yRange = Y_RANGE, margin = 0) {
  return points.every(
    (point) =>
      point.x >= xRange[0] + margin &&
      point.x <= xRange[1] - margin &&
      point.y >= yRange[0] + margin &&
      point.y <= yRange[1] - margin &&
      Number.isInteger(point.x) &&
      Number.isInteger(point.y)
  );
}

function transformPoint(point, kind, factor) {
  if (kind === "vertical") return { ...point, y: point.y * factor };
  return { ...point, x: point.x / factor };
}

function transformPolyline(points, kind, factor) {
  return points.map((point) => transformPoint(point, kind, factor)).sort((a, b) => a.x - b.x);
}

function pointKey(point) {
  return point.x + ":" + point.y;
}

function endPointKeys(points) {
  if (!Array.isArray(points) || points.length === 0) return new Set();
  return new Set([pointKey(points[0]), pointKey(points[points.length - 1])]);
}

function hasOverlappingEndpoints(base, expected) {
  const baseEnds = endPointKeys(base);
  return endPointKeys(expected).size > 0 && [...endPointKeys(expected)].some((key) => baseEnds.has(key));
}

function getValidShapes(kind, factor) {
  return baseShapes
    .map((base) => ({ base, expected: transformPolyline(base, kind, factor) }))
    .filter(
      ({ base, expected }) =>
        inRange(base, X_RANGE, Y_RANGE, EDGE_MARGIN) &&
        inRange(expected, X_RANGE, Y_RANGE, EDGE_MARGIN) &&
        !hasOverlappingEndpoints(base, expected)
    );
}

function makeTask(family) {
  const { kind, factors } = family;
  const factor = pick(factors);
  const validShapes = getValidShapes(kind, factor);

  if (validShapes.length > 0) {
    return { ...pick(validShapes), kind, factor };
  }

  for (const fallbackFactor of factors) {
    const fallbackShapes = getValidShapes(kind, fallbackFactor);
    if (fallbackShapes.length > 0) return { ...pick(fallbackShapes), kind, factor: fallbackFactor };
  }

  const base = baseShapes[0];
  const expected = transformPolyline(base, kind, factor);
  return { base, expected, kind, factor };
}

function factorLatex(factor) {
  if (factor === 0.5) return "\\frac{1}{2}";
  if (factor === -0.5) return "-\\frac{1}{2}";
  if (factor === 1 / 3) return "\\frac{1}{3}";
  if (factor === -1 / 3) return "-\\frac{1}{3}";
  return String(factor);
}

function formulaLatex(kind, factor) {
  const k = factorLatex(factor);
  if (kind === "vertical") return "g(x)=" + k + "f(x)";
  return "g(x)=f(" + k + "x)";
}

function transformationText(kind, factor) {
  if (kind === "vertical") {
    return (
      <>
        pomno&#380;enie warto&#347;ci funkcji przez <InlineMath math={factorLatex(factor)} />
      </>
    );
  }

  return (
    <>
      pomno&#380;enie argumentu funkcji przez <InlineMath math={factorLatex(factor)} />
    </>
  );
}

export function generateTask(option) {
  const fallbackFamilies = Object.values(factorFamilies);
  const familyKey = legacyFamilyAliases[option] || option;
  const family = factorFamilies[familyKey] || pick(fallbackFamilies);
  const data = makeTask(family);
  return {
    type: "ScaleGraphSketchTask",
    data: { ...data, xRange: X_RANGE, yRange: Y_RANGE },
  };
}

export function renderTask({ data }) {
  return (
    <div style={{ marginTop: 6 }}>
      <p>
        Na podstawie fioletowego wykresu funkcji <InlineMath math={"f"} /> dorysuj pomara&#324;czowy wykres funkcji{" "}
        <InlineMath math={"g"} />, okre&#347;lonej wzorem <InlineMath math={formulaLatex(data.kind, data.factor)} />.
      </p>
    </div>
  );
}

export function renderInput(task, userInput = {}, onChange, disabled) {
  return (
    <PolylineGraphInput
      value={userInput}
      onChange={onChange}
      disabled={disabled}
      xRange={task.data.xRange}
      yRange={task.data.yRange}
      referencePoints={task.data.base}
      referenceColor="#8b5cf6"
      answerColor="#ff9900"
    />
  );
}

function ExercisePolylineInput({ task }) {
  const [value, setValue] = React.useState({ points: [] });
  return renderInput(task, value, setValue, false);
}

export function renderExerciseTask(task) {
  return (
    <div>
      {renderTask(task)}
      <ExercisePolylineInput task={task} />
    </div>
  );
}

export function checkAnswer(task, userInput = {}) {
  return samePoints(userInput.points, task.data.expected);
}

export function renderAnswer({ data }) {
  return (
    <PolylineGraphInput
      value={{ points: data.expected }}
      disabled
      xRange={data.xRange}
      yRange={data.yRange}
      referencePoints={data.base}
      referenceColor="#8b5cf6"
      answerColor="#ff9900"
      showControls={false}
    />
  );
}

export function renderExplanation({ data }) {
  return (
    <div style={{ textAlign: "left", lineHeight: 1.7 }}>
      <p>
        <strong>Krok 1.</strong> Rozpoznaj typ skalowania: {transformationText(data.kind, data.factor)}.
      </p>
      <p>
        <strong>Krok 2.</strong> Przelicz punkty fioletowej &#322;amanej. Dla{" "}
        <InlineMath math={"g(x)=k f(x)"} /> zmieniaj&#261; si&#281; warto&#347;ci <InlineMath math={"y"} />, a dla{" "}
        <InlineMath math={"g(x)=f(kx)"} /> punkt o argumencie <InlineMath math={"x"} /> trafia na{" "}
        <InlineMath math={"\\frac{x}{k}"} />.
      </p>
      <p>
        <strong>Krok 3.</strong> Po&#322;&#261;cz przeliczone punkty w tej samej kolejno&#347;ci wzd&#322;u&#380; wykresu.
      </p>
      {renderAnswer({ data })}
    </div>
  );
}

export function renderUserAnswer(arg1 = {}, arg2 = {}) {
  const firstIsTask = arg1?.type === "ScaleGraphSketchTask";
  const task = firstIsTask ? arg1 : arg2?.type === "ScaleGraphSketchTask" ? arg2 : null;
  const userInput = firstIsTask ? arg2 : arg1;
  const points = Array.isArray(userInput?.points) ? userInput.points : [];
  if (!points.length) return <i>(brak odpowiedzi)</i>;
  if (!task?.data) return <span>{points.map((point) => "(" + point.x + ", " + point.y + ")").join(" - ")}</span>;

  return (
    <div style={{ marginTop: 8 }}>
      <PolylineGraphInput
        value={{ points }}
        disabled
        xRange={task.data.xRange}
        yRange={task.data.yRange}
        referencePoints={task.data.base}
        referenceColor="#8b5cf6"
        answerColor="#ff9900"
        showControls={false}
      />
    </div>
  );
}

export default {
  generateTask,
  renderTask,
  renderInput,
  renderExerciseTask,
  checkAnswer,
  renderAnswer,
  renderExplanation,
  renderUserAnswer,
};
